import { TableComissaoCorretora } from "./components/table/TableComissaoCorretora";

export const PageComissaoCorretora = () => {
  return (
    <TableComissaoCorretora />
  );
};
